import React from "react";
import EmailLink from "./EmailLink";
import { Translations } from "../translations";

const DirectBillEmailLink = () => (
  <EmailLink email={Translations.corp_emails.direct_bill} />
);

export default DirectBillEmailLink;
